export var LanguageType;
(function (LanguageType) {
    LanguageType[LanguageType["Core"] = 0] = "Core";
    LanguageType[LanguageType["NonCore"] = 1] = "NonCore";
    LanguageType[LanguageType["Unsupported"] = 2] = "Unsupported";
})(LanguageType || (LanguageType = {}));
export default LanguageType;
//# sourceMappingURL=language-type.js.map